// Language display names and TM label helpers

export const LANGUAGE_LABELS = {
  'en-US': 'English',
  'es-US': 'Spanish',
  'ar-SA': 'Arabic',
  'nl-NL': 'Dutch',
  'fr-FR': 'French',
  'de-DE': 'German',
  'ja-JP': 'Japanese',
  'pt-PT': 'Portuguese',
  'zh-CN': 'Chinese',
};

export const DEFAULT_TM_ID = 'domestic#es-US#general';

export function getLanguageLabel(code) {
  return LANGUAGE_LABELS[code] || code || 'Translation';
}

export function getSourceLabel(request) {
  const lang = request?.sourceLanguage || 'en-US';
  return getLanguageLabel(lang);
}

export function getTargetLabel(request) {
  const lang = request?.targetLanguage || 'es-US';
  return getLanguageLabel(lang);
}

export function getLanguagePairLabel(request, compact = false) {
  const src = request?.sourceLanguage || 'en-US';
  const tgt = request?.targetLanguage || 'es-US';
  if (compact) {
    const srcShort = src.split('-')[0].toUpperCase();
    const tgtShort = tgt.split('-')[0].toUpperCase();
    return `${srcShort} → ${tgtShort}`;
  }
  return `${getLanguageLabel(src)} → ${getLanguageLabel(tgt)}`;
}

export function resolveTmId(request, availableTMs = []) {
  if (request?.tm_id) return request.tm_id;
  const program = request?.program || 'domestic';
  const targetLanguage = request?.targetLanguage || 'es-US';
  const category = request?.category || 'general';
  const derived = `${program}#${targetLanguage}#${category}`;
  const found = availableTMs.find((t) => t.tm_id === derived);
  if (found) return derived;
  if (availableTMs.length === 1) return availableTMs[0].tm_id;
  return derived || DEFAULT_TM_ID;
}

export function getTmDisplayName(tmId, availableTMs = []) {
  if (!tmId) return '';
  const found = availableTMs.find(t => t.tm_id === tmId);
  if (found) return found.label;
  // Derive from tm_id format: program#targetLanguage#category
  const parts = tmId.split('#');
  if (parts.length === 3) {
    const [program, lang, category] = parts;
    return `${program} - ${category} (${getLanguageLabel(lang)})`;
  }
  return tmId;
}

export function getColumnLabelsForTm(selectedTm) {
  const targetLanguage = selectedTm?.targetLanguage || 'es-US';
  const sourceLanguage = selectedTm?.sourceLanguage || 'en-US';
  return {
    source: getLanguageLabel(sourceLanguage),
    target: getLanguageLabel(targetLanguage),
    sourceCode: sourceLanguage,
    targetCode: targetLanguage,
    pairLabel: `${getLanguageLabel(sourceLanguage)} → ${getLanguageLabel(targetLanguage)}`,
  };
}

export function batchLanguageContext(batch, availableTMs = []) {
  if (!batch) return null;
  const pseudo = {
    tm_id: batch.tm_id,
    program: batch.program,
    targetLanguage: batch.targetLanguage,
    category: batch.category,
    sourceLanguage: 'en-US',
  };
  return {
    tmId: resolveTmId(pseudo, availableTMs),
    tmName: getTmDisplayName(resolveTmId(pseudo, availableTMs), availableTMs),
    pairLabel: getLanguagePairLabel(pseudo),
  };
}
